<template>
  <div class="main">
    <vue-headful title="阀门专用工具查询" description="阀门专用工具查询" />
    <div class="header">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="container">
      <div class="logo">
        <img src="../assets/spxflow-logo-2C.png" alt="SPX logos" />
      </div>
      <div class="desc">若您在随机手册上查询到的阀门备件号是旧版本，希望查询对应的新设备号，或希望查询现有阀门备件号对应的老版本号码，请在此进行搜索。</div>
      <div class="contents">
        <div class="inputs">
          <span class="input-search" id="search-input">
            <input type="text" class="form-control input-sm" id="search" name="search" value="" placeholder="请输入设备编号" autocomplete="on" v-model="number" />
          </span>
          <button class="btn btn-success" @click="search()">搜索</button>
        </div>
        <div class="table-div">
          <div class="head">查询结果</div>
          <table class="table table-bordered table1">
            <tbody>
              <tr>
                <th>产品名</th>
                <th>旧版编号</th>
                <th>新版编号</th>
              </tr>
              <tr class="search-res">
                <td>
                  <span>{{ result.product_name }}</span>
                </td>
                <td>{{ result.old_number }}</td>
                <td>{{ result.new_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-div">
          <div class="head" style="position: relative">
            查询历史
            <span class="del" @click="del()">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </div>
          <table class="table table-bordered table2">
            <thead>
              <tr>
                <th>产品名</th>
                <th>旧版编号</th>
                <th>新版编号</th>
              </tr>
            </thead>
            <tbody class="history-search">
              <tr v-for="(history, idx) in histories" :key="idx">
                <td>
                  <span>{{ history ? history.product_name : "" }}</span>
                </td>
                <td>{{ history ? history.old_number : "" }}</td>
                <td>{{ history ? history.new_number : "" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { searchProduct } from "@/api/request";

export default {
  name: "valve",
  data() {
    return {
      number: null,
      result: {},
      histories: [null, null, null],
    };
  },
  methods: {
    async del() {
      let answer = await Dialog.confirm({
        title: "提示",
        message: "是否清除历史记录？",
      });
      if (answer) {
        localStorage.removeItem("history_search_res");
        this.histories = [null, null, null];
      } else {
        console.log(1);
      }
    },
    async search() {
      if (this.number == null || this.number == "") {
        Toast("请输入设备编号查询");
        return;
      }
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let product = await searchProduct({
          number: this.number,
        });
        if (product.data != null) {
          this.result = product.data;
          let his_clone = JSON.parse(JSON.stringify(this.histories));
          if (his_clone.every((i) => i === null)) {
            this.histories = [product.data];
          } else {
            if (!his_clone.some((i) => i.product_name == product.data.product_name && i.old_number == product.data.old_number && i.new_number == product.data.new_number)) {
              this.histories.push(product.data);
            }
          }
          localStorage.setItem("history_search_res", JSON.stringify(this.histories));
        } else {
          Toast("未查询到该编号");
        }
        loader.hide();
      } catch (error) {
        // Toast(error);
        loader.hide();
      }
    },
  },
  async mounted() {
    let histories = localStorage.getItem("history_search_res");
    if (histories) {
      this.histories = JSON.parse(histories);
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 30px;
  box-sizing: border-box;
  min-height: calc(100vh - 206px);
  .logo {
    img {
      margin: 20px auto;
      width: 250px;
    }
  }
  .name {
    font-weight: 700;
    font-size: 18px;
    color: rgba(101, 99, 99, 1);
  }
  .desc {
    color: #656464;
    margin: 0px 24px 24px 24px;
    text-align: left;
    line-height: 32px;
  }
  .contents {
    padding: 0 24px;
  }

  .inputs {
    display: flex;
  }

  .input-search {
    flex: 1;
    margin-right: 10px;
    .form-control {
      display: block;
      width: 100%;
      height: 36px;
      padding: 6px 12px;
      box-sizing: border-box;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }
    #search {
      border: 1px solid #1d4f48;
      background: url(../assets/search.png) no-repeat scroll right center transparent;
      background-position: 95%;
    }
  }
}
.btn {
  display: inline-block;
  font-weight: 400;
  width: 20%;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  color: #fff;
  background-color: #1d4f48;
  border-color: #1d4f48;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table .table {
  background-color: #fff;
}

.table-sm td,
.table-sm th {
  padding: 0.3rem;
}

.table-bordered,
.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}

.table-borderless tbody + tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > td,
.table-primary > th {
  background-color: #b8daff;
}

.table-hover .table-primary:hover,
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #9fcdff;
}

.table-secondary,
.table-secondary > td,
.table-secondary > th {
  background-color: #d6d8db;
}

.table-hover .table-secondary:hover,
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > td,
.table-success > th {
  background-color: #c3e6cb;
}

.table-hover .table-success:hover,
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #b1dfbb;
}

.table-info,
.table-info > td,
.table-info > th {
  background-color: #bee5eb;
}

.table-hover .table-info:hover,
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #abdde5;
}

.table-warning,
.table-warning > td,
.table-warning > th {
  background-color: #ffeeba;
}

.table-hover .table-warning:hover,
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger,
.table-danger > td,
.table-danger > th {
  background-color: #f5c6cb;
}

.table-hover .table-danger:hover,
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f1b0b7;
}

.table-light,
.table-light > td,
.table-light > th {
  background-color: #fdfdfe;
}

.table-hover .table-light:hover,
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark,
.table-dark > td,
.table-dark > th {
  background-color: #c6c8ca;
}

.table-hover .table-dark:hover,
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active,
.table-active > td,
.table-active > th,
.table-hover .table-active:hover,
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-div {
  margin-top: 30px;
}
.table-div .head {
  padding-left: 5px;
  line-height: 30px;
  border-left: 6px solid #1d4f48;
  text-align: left;
  color: grey;
}
.table1 {
  margin-top: 8px;
}
.table1 th {
  padding: 0.45rem;
  background-color: #1d4f48;
  color: white;
  font-weight: normal;
  font-size: 14px;
}
.table1 td {
  padding: 0.45rem;
  background-color: #eaeaea;
  font-size: 14px;
}
.table2 {
  margin-top: 8px;
}
.table2 th {
  padding: 0.45rem;
  background-color: #6e6e6e;
  color: white;
  font-weight: normal;
  font-size: 14px;
}
.table2 td {
  padding: 0.45rem;
  background-color: #eaeaea;
  font-size: 14px;
}

.del {
  display: block;
  width: 30px;
  height: 30px;
  font-size: 12px;
  margin-right: 4px;
  float: right;
  background-image: url(../assets/trash.png);
  background-repeat: no-repeat;
  background-size: 15px;
  background-position: 10px 8px;
}

td {
  span {
    display: inline-block;
  }
}

.float {
  position: fixed;
  bottom: 20%;
  right: 0;
  img {
    width: 51px;
  }
}
</style>
